import {default as WebComponent} from './web-component';

import { default as Button } from './button';
import { default as Field } from './field';
import { default as FieldText } from './field-text';
import { default as FieldUserDefined } from './field-user-defined';
import { default as FieldSelection } from './field-selection';

export default {
    get WebComponent () {
        return WebComponent;
    },

    get Button () {
        return Button();
    },
    get Field () {
        return Field();
    },
    get FieldUserDefined () {
        return FieldUserDefined();
    },
    get FieldText () {
        return FieldText();
    },
    get FieldSelection() {
        return FieldSelection();
    },
};